import * as actionTypes from "../actionTypes";

export const getOperator = payload => ({
    type: actionTypes.GET_OPERATOR,
    payload
})

export const setOperator = payload => ({
    type: actionTypes.SET_OPERATOR,
    payload
})

export const getOperatorImages = payload => ({
    type: actionTypes.GET_OPERATOR_IMAGES,
    payload
})

export const setOperatorImages = payload => ({
    type: actionTypes.SET_OPERATOR_IMAGES,
    payload
})

export const createOperatorImages = payload => ({
    type: actionTypes.CREATE_OPERATOR_IMAGES,
    payload
})

export const updateOperatorImages = payload => ({
    type: actionTypes.UPDATE_OPERATOR_IMAGES,
    payload
})

export const deleteOperatorImages = payload => ({
    type: actionTypes.DELETE_OPERATOR_IMAGES,
    payload
})
